import React from "react";
import clsx from "clsx";
import { createMemoClass } from "../create-memo-class";
import { usePaddingClasses } from "../shared-classes";
import { jsx as _jsx } from "react/jsx-runtime";
export var TextV2 = _ref => {
  var {
    color,
    padding,
    content,
    className
  } = _ref;
  var classes = useTextV2Class({
    color,
    padding
  });
  return /*#__PURE__*/_jsx("article", {
    className: clsx(classes, className),
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
};
export var useTextV2Class = createMemoClass(props => {
  var padding = usePaddingClasses(props.padding);
  var colors = {
    foreground: "text-foreground prose-headings:text-foreground prose-a:text-foreground prose-strong:text-foreground prose-em:text-foreground",
    inherit: "text-inherit prose-headings:text-inherit prose-a:text-inherit prose-strong:text-inherit prose-em:text-inherit"
  };
  var classes = clsx("prose prose-lg md:prose-xl xl:prose-2xl max-w-full", colors[props.color || "inherit"], padding);
  return classes;
});
//# sourceMappingURL=text_v2.js.map